import ArchivedTable from './ArchivedTable'
export default ArchivedTable
